export default "__VITE_ASSET__e1c72c47__"